(function () {
  'use strict';

  const cfg = window.__themeCollectionConfig || {};

  // Critical for browsing
  import(cfg.productCard);
  import(cfg.quickAdd);

  // Secondary — after idle
  function loadSecondary() {
    import(cfg.productPrice);
    import(cfg.productTitleTruncation);
    import(cfg.media);
    import(cfg.videoBackground);
    import(cfg.quantitySelector);
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadSecondary, { timeout: 3000 });
  } else {
    setTimeout(loadSecondary, 100);
  }
})();